import React from "react";
import AniLink from "gatsby-plugin-transition-link/AniLink";

const Button = ({
  className,
  href,
  outboundLink,
  modal,
  onClick,
  type,
  altStyle,
  text,
}) => {
  const Tag = href ? AniLink : "button";
  const target = outboundLink && "_blank";
  const rel = outboundLink && "noopener noreferrer";
  let link = true;

  href && (link = !href.includes("tel:") && !href.includes("mailto:"));

  return (
    <Tag
      className={`group relative inline-flex text-primary-600 hover:text-primary-600 font-bold ${className}`}
      {...(link ? { fade: "true", to: href } : { href: href })}
      target={target}
      rel={rel}
      data-modal-open={modal}
      onClick={onClick}
      type={type}
      alt-style={altStyle}
    >
      <div className="relative">
        {text}
        <span className="absolute w-full group-hover:w-0 -bottom-2 left-0 group-hover:left-auto right-auto group-hover:right-0 bg-primary-600 h-0.5 transition-all duration-500 ease-in-out"></span>
      </div>
    </Tag>
  );
};

export default Button;
